import React from "react";

function RegistrationInfo({ formData, setFormData ,eventPrice, eventType , seteventprice , setcheckBoxStates , checkBoxStates}) {

  return (
     
    

<div className="sign-up-container">
<br/>


<table>
 <tr>
  { eventType.current === "DURGA_PUJO" ? 
  <td style= {{ width:'90%'}}>
        
            All-Days:
            <input
              class = 'udaanchckbx'
              type="checkbox"
              name="eventDays"
              value="All days"
              checked={checkBoxStates.isAllDayChecked}
              onChange={() => setcheckBoxStates({ ...checkBoxStates, isSaturdayChecked: false, isSundayChecked : false , isEventChecked: false , isAllDayChecked : !checkBoxStates.isAllDayChecked})}
           
            />    &nbsp;&nbsp; 
        
          {eventPrice.satOnlyStatus === "A" && 
          <>
            Saturday-Only:
            <input
              class = 'udaanchckbx'
              type="checkbox"
              name="eventDays"
              value="Saturday Only"
              checked= {checkBoxStates.isSaturdayChecked}
              onChange={() => setcheckBoxStates({ ...checkBoxStates, isSaturdayChecked: !checkBoxStates.isSaturdayChecked , isSundayChecked : false , isEventChecked: false , isAllDayChecked : false})}
     
            />&nbsp;&nbsp;
            </>
          }

          {eventPrice.sunOnlyStatus === "A" && 
          <>
            Sunday-only:
            <input
              class = 'udaanchckbx'
              type="checkbox"
              name="eventDays"
              value="Sunday only"
              checked= {checkBoxStates.isSundayChecked}
               onChange={() => setcheckBoxStates({ ...checkBoxStates, isSaturdayChecked: false, isSundayChecked : !checkBoxStates.isSundayChecked , isEventChecked: false , isAllDayChecked : false})}
  
            />&nbsp;&nbsp;
            </>
            }

          {eventPrice.eventOnlyStatus === "A" && 
          <>
            Event-only:
            <input
              class = 'udaanchckbx'
              type="checkbox"
              name="eventDays"
              value="Event only"
              checked= {checkBoxStates.isEventChecked}
               onChange={() => setcheckBoxStates({ ...checkBoxStates, isSaturdayChecked: false, isSundayChecked : false , isEventChecked: !checkBoxStates.isEventChecked , isAllDayChecked : false})}

            />
            </>
          }
         
        </td> : <td></td>
}
      </tr> 


</table>

<br/>

<div className="other-info-container">
  {!checkBoxStates.isEventChecked &&
  <>
     <tr><td><label >Ticket Price for Adults (Non-veg): <label style={{fontWeight:'bold'}} > ${ checkBoxStates.isAllDayChecked? eventPrice.priceAdult: checkBoxStates.isSundayChecked ? eventPrice.sundayPriceAdult: checkBoxStates.isSaturdayChecked ? eventPrice.saturdayPriceAdult: eventPrice.priceAdultEvent  } </label> </label></td></tr>
     <tr><td><label >Ticket Price for Adults (Veg): <label style={{fontWeight:'bold'}} >     ${ checkBoxStates.isAllDayChecked? eventPrice.priceAdult: checkBoxStates.isSundayChecked ? eventPrice.sundayPriceAdult: checkBoxStates.isSaturdayChecked ? eventPrice.saturdayPriceAdult: eventPrice.priceAdultEvent  } </label> </label></td></tr>
     <tr><td><label >Ticket Price for kids (Age Below 6): <label style={{fontWeight:'bold'}} >${ checkBoxStates.isAllDayChecked? eventPrice.priceBelow6: checkBoxStates.isSundayChecked ? eventPrice.sundayPriceBelow6: checkBoxStates.isSaturdayChecked ? eventPrice.saturdayPriceBelow6: eventPrice.priceAdultEvent  } </label> </label></td> </tr>
     <tr><td><label >Ticket Price for kids (Age 6-12): <label style={{fontWeight:'bold'}} >  ${ checkBoxStates.isAllDayChecked? eventPrice.price6to12: checkBoxStates.isSundayChecked ? eventPrice.sundayPrice6To12: checkBoxStates.isSaturdayChecked ? eventPrice.saturdayPrice6To12: eventPrice.priceAdultEvent  }</label> </label></td></tr>
     </>
  }

    {checkBoxStates.isEventChecked &&
  <>
     <tr><td><label >Ticket Price for Attendees : <label style={{fontWeight:'bold'}} > ${  eventPrice.eventOnlyPriceAdult } </label> </label></td></tr>
     </>
  }
  
    
    </div> 
    <table>     
       
       {!checkBoxStates.isEventChecked &&

       <>

        <tr>
            <td><label for="quantity_veg">Number of Adults (Non-veg) :</label></td>
            <td><input type="number" id="quantity_adult" name="quantity_adult" min="1" max="5" value={formData.totalNonveg} onChange={(event) => setFormData({ ...formData, totalNonveg: event.target.value })} /></td>
        </tr>
         <tr>
            <td><label for="quantity_veg">Number of Adults (Veg) :</label></td>
            <td><input type="number" id="quantity_adult" name="quantity_adult" min="1" max="5" value={formData.totalVeg} onChange={(event) => setFormData({ ...formData, totalVeg: event.target.value })} /></td>
        </tr>
          <tr>
            <td><label for="quantity_below_6">Number of Kids (Age Below 6) :</label></td>
            <td><input type="number" id="quantity_below_6" name="quantity_below_6" min="1" max="5" value={formData.numberBelow6} onChange={(event) => setFormData({ ...formData, numberBelow6: event.target.value })}  /></td>
        </tr>
        <tr>
            <td><label for="quantity_6_12">Number of Kids (Age 6-12) :</label></td>
            <td><input type="number" id="quantity_6_12" name="quantity_6_12" min="1" max="5" value={formData.numberBetween6To12} onChange={(event) => setFormData({ ...formData, numberBetween6To12: event.target.value })} /></td>
        </tr>

        </>
  }

  {checkBoxStates.isEventChecked &&
       <>
        <tr>
            <td><label for="quantity_veg">Number of Adults :</label></td>
            <td><input type="number" id="quantity_adult" name="quantity_adult" min="1" max="5" value={formData.numberOfAdult} onChange={(event) => setFormData({ ...formData, numberOfAdult: event.target.value })} /></td>
        </tr>
        </>
  }

    </table> 
    </div>
  );
}

export default RegistrationInfo;
